import { useQuery } from '@tanstack/react-query';
import type { InvitePreviewDto } from '@mondy/shared';
import { api } from '@/api';

interface InvitePreviewResponse {
  preview: InvitePreviewDto;
}

/**
 * Unauthenticated: preview a group invite by its single-use token. Used on
 * `/accept_group_invite/:token` to render the greeting card, and (optionally)
 * on Signup to show "You're signing up to join {groupName}".
 *
 * The caller should handle these expected errors via `query.error`:
 *   - 404 INVITE_INVALID
 *   - 410 INVITE_EXPIRED
 */
export function useInvitePreview(token: string | null) {
  return useQuery({
    queryKey: ['invites', 'preview', token] as const,
    queryFn: () =>
      api.get<InvitePreviewResponse>(`/api/invites/${token}/preview`),
    enabled: Boolean(token),
    retry: false,
    staleTime: 60_000,
  });
}
